import moment from 'moment/moment';
import { config } from './../constants/domainConfig';
import { bidiotvMovies } from './../constants/bidiotvmovies';
import { bidiotvMoviesId } from './../constants/bidiotvmovies_id';
import { bidiotvMoviesIt } from './../constants/bidiotvmovies_it';
import { bidiotvMoviesSa } from './../constants/bidiotvmovies_sa';
import { bidiotvMoviesPk } from './../constants/bidiotvmovies_pk';
import { bidiotvMoviesCa } from './../constants/biditvmovies_ca';
import { bidiotvMoviesSn } from '../constants/bidiotvmovies_sn';
import { bidiotvMoviesTr } from '../constants/bidiotvmovies_tr';
import { bidiotvMoviesTh } from '../constants/bidiotvmovies_th';
import { bidiotvMoviesKe } from '../constants/bidiotvmovies_ke';
import { bidiotvMoviesIq } from "../constants/bidiotvmovies_iq";
import { bidiotvMoviesGH } from './../constants/bannerDetails_gh';
import { bidiotvMoviesPt } from '../constants/bidiotvmovies_pt';
import { videos360 } from '../constants/videos360';
import { videos_za_premium } from "../constants/videos_za";
import { mobioFitVideos } from '../constants/mobiofit_videos';
import qs from "query-string";

export const console_log = (param1, param2) => {
    if (param2) {
        console.log(param1, param2);
    } else {
        console.log(param1);
    }
};

export const parseQueryString = (url) => {
    var urlParams = {};
    url.replace(
        new RegExp("([^?=&]+)(=([^&]*))?", "g"),
        function ($0, $1, $2, $3) {
            urlParams[$1] = $3;
        }
    );

    return urlParams;
};

export const jsUcfirst = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatDate = (date, format) => {
    return moment(date).format(format);
};

export const isBetween = (date, start, end) => {
    return moment(date).isBetween(start, end);
};

export const fromNow = (dateTime) => {
    return moment(dateTime).fromNow();
};

export const getSubdomain = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    return parts[0];
}

export const getParameterByName = (name, url) => {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return null;
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
export const shuffle = (videoArray) => {
    let ctr = videoArray.length;
    let temp;
    let index;

    // While there are elements in the array
    while (ctr > 0) {
        // Pick a random index
        index = Math.floor(Math.random() * ctr);
        // Decrease ctr by 1
        ctr--;
        // And swap the last element with it
        temp = videoArray[ctr];
        videoArray[ctr] = videoArray[index];
        videoArray[index] = temp;
    }
    return videoArray;
}

export let bidiotvMoviesListByLang = [];
export const getBidiotvMoviesListByLang = () => {
    if (config.lang == 'id') {
        bidiotvMoviesListByLang = bidiotvMoviesId;
    } else if (config.subDomain === 'it') {
        bidiotvMoviesListByLang = bidiotvMoviesIt.concat(bidiotvMovies)
    }
     else if (config.subDomain === 'sa' || config.subDomain === 'mh') {
        bidiotvMoviesListByLang = bidiotvMoviesSa
    } else if(config.subDomain === 'iq'){
        bidiotvMoviesListByLang = bidiotvMoviesIq
    } else if (config.subDomain === 'pk') {
        bidiotvMoviesListByLang = bidiotvMoviesPk
    } else if (config.subDomain === 'ca') {
        bidiotvMoviesListByLang = bidiotvMoviesCa.concat(bidiotvMovies)
    } else if (config.subDomain === 'sn') {
        bidiotvMoviesListByLang = bidiotvMoviesSn
    } else if(config.subDomain === 'tr') {
        bidiotvMoviesListByLang = bidiotvMoviesTr
    }
    else if (config.subDomain.includes('mobiofit')) {
        bidiotvMoviesListByLang = mobioFitVideos
    }
    else if (config.subDomain === 'premium') {
        bidiotvMoviesListByLang = videos_za_premium
    }
    else if(config.subDomain === 'no'){
        bidiotvMoviesListByLang = videos360.concat(bidiotvMovies)
    }
   else if(config.subDomain==='maxis'){
       let excludeVideos=["All the political statements in Miley Cyrus's new music video","Scarlett Johansson's latest political gaffe defending Woody Allen"];
         let findCategory=_.find(bidiotvMovies,(value)=>(
             value.name[config.lang]==="Entertainment News"
        ));
       let updatedVideos=findCategory.videos.filter((videos)=>(
         excludeVideos.indexOf(videos.name)<0
        ));
      let index=bidiotvMovies.findIndex(x=>x.name[config.lang]==="Entertainment News");
      bidiotvMovies[index].videos=updatedVideos;

    bidiotvMoviesListByLang = [...bidiotvMovies,...mobioFitVideos].filter((value)=>(
        value.name[config.lang]!="Political & Activism" 
    ));
    }
    else if(config.subDomain==='th'){
        bidiotvMoviesListByLang = bidiotvMoviesTh;
    }
    else if(config.subDomain==='ke'){
        bidiotvMoviesListByLang = bidiotvMoviesKe;
    }
    else if(config.subDomain==='gh'){
        bidiotvMoviesListByLang=bidiotvMoviesGH.concat(bidiotvMovies)
    }
    else if(config.subDomain === 'pt'){
        bidiotvMoviesListByLang = bidiotvMoviesPt.concat(bidiotvMovies)
    }
    else {
        bidiotvMoviesListByLang = bidiotvMovies;
    }
}
const hashToQuery = () => {
    const d = window.location.hash.slice(1);
    if (d[0] === "/") return d.slice(1);
    else return d;
  };
  export const getParameters = (params) => {
    const queryStrings = qs.parse(window.location.search);
    const hashQueryStrings = qs.parse(hashToQuery());
    const d = queryStrings[params] || hashQueryStrings[params];
    return {
     exist: d && d.length > 0,
     value: d
    };
  };



// WEBPACK FOOTER //
// ./src/utils/helper.js